/**
 * Controller Registration
 *
 * Import and register all Stimulus controllers here
 */

import { application } from "./application"

// Import controllers
import AccordionController from "./accordion_controller"
import TripSliderController from "./trip_slider_controller"
import TripsBlockFilterController from "./trips_block_filter_controller"
import TripsSliderController from "./trips_slider_controller"
import GoogleMapController from "./google_map_controller"
import ContentSliderController from "./content_slider_controller"
import ItinerarySliderController from "./itinerary_slider_controller"
import EmployeeSliderController from "./employee_slider_controller"
import TabsController from "./tabs_controller"
import HeroVideoController from "./hero_video_controller"

// Register controllers
application.register("accordion", AccordionController)
application.register("trip-slider", TripSliderController)
application.register("trips-block-filter", TripsBlockFilterController)
application.register("trips-slider", TripsSliderController)
application.register("google-map", GoogleMapController)
application.register("content-slider", ContentSliderController)
application.register("itinerary-slider", ItinerarySliderController)
application.register("employee-slider", EmployeeSliderController)
application.register("tabs", TabsController)
application.register("hero-video", HeroVideoController)

// Example: Import and register a toggle controller
// import ToggleController from "./toggle_controller"
// application.register("toggle", ToggleController)

// Add your controllers here as you create them

